module.exports = __webpack_public_path__ + "static/img/欢乐岛整体背景@2x.27dfe8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/欢乐岛整体背景@2x.png
// module id = v2HO
// module chunks = 1